import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Star, Quote } from "lucide-react";
import Autoplay from "embla-carousel-autoplay";
import { useRef } from "react";
const Testimonials = () => {
  const plugin = useRef(
    Autoplay({ delay: 4000, stopOnInteraction: true })
  );
  
  const testimonials = [{
    name: "Member 1",
    role: "Small Business Owner",
    location: "Nairobi",
    image: "/api/placeholder/80/80",
    rating: 5,
    text: "Natcon Sacco helped me expand my grocery business with their quick development loan. The process was seamless and the staff was very supportive throughout."
  }, {
    name: "Member 2",
    role: "Teacher",
    location: "Eldoret",
    image: "/api/placeholder/80/80",
    rating: 5,
    text: "I've been saving with Natcon for 8 years now. The dividend rates are excellent and I was able to build my house through their development loan"
  }, {
    name: "Member 3",
    role: "Nurse",
    location: "Kisumu",
    image: "/api/placeholder/80/80",
    rating: 5,
    text: "The school fees loan service is a lifesaver. My children's education has never been interrupted, and the flexible repayment terms work perfectly with my salary."
  }, {
    name: "Member 4",
    role: "Engineer",
    location: "Nakuru",
    image: "/api/placeholder/80/80",
    rating: 5,
    text: "I secured an emergency loan within 48 hours when I needed it most. The competitive interest rates and flexible repayment options have made Natcon my trusted financial partner for years."
  }, {
    name: "Member 5",
    role: "Entrepreneur",
    location: "Mombasa",
    image: "/api/placeholder/80/80",
    rating: 4,
    text: "My loan application took longer than expected. I was guided properly and understood the issues at hand. I wish we could get loans with 3 days. Kudos"
  }];
  return <section className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            What Our Members Say
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Join thousands of satisfied members who have achieved their financial goals with Natcon Sacco
          </p>
        </div>

        <Carousel
          plugins={[plugin.current]}
          opts={{
            align: "start",
            loop: true,
            dragFree: false,
            containScroll: "trimSnaps",
          }}
          className="w-full max-w-5xl mx-auto"
          onMouseEnter={plugin.current.stop}
          onMouseLeave={plugin.current.reset}
        >
          <CarouselContent className="-ml-2 md:-ml-4">
            {testimonials.map((testimonial, index) => (
              <CarouselItem key={index} className="pl-2 md:pl-4 md:basis-1/2 lg:basis-1/3">
                <div className="p-1">
                  <Card className="bg-card shadow-soft hover:shadow-medium transition-all duration-300 border-border/50">
                    <CardContent className="p-6">
                      <div className="space-y-4">
                        {/* Quote Icon */}
                        <Quote className="h-8 w-8 text-primary/20" />
                        
                        {/* Rating */}
                        <div className="flex gap-1">
                          {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-accent text-accent" />)}
                        </div>

                        {/* Testimonial Text */}
                        <p className="text-muted-foreground leading-relaxed text-sm">
                          "{testimonial.text}"
                        </p>

                        {/* Member Info */}
                        <div className="flex items-center gap-3 pt-4 border-t border-border/50">
                          <div className="h-12 w-12 rounded-full bg-gradient-primary flex items-center justify-center">
                            <span className="text-white font-semibold">
                              {testimonial.name.split(' ').map(n => n[0]).join('')}
                            </span>
                          </div>
                          <div>
                            <div className="font-semibold text-foreground text-sm">{testimonial.name}</div>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex -left-12 lg:-left-16" />
          <CarouselNext className="hidden md:flex -right-12 lg:-right-16" />
        </Carousel>

        {/* Mobile swipe hint */}
        <div className="md:hidden text-center mt-6">
          <p className="text-xs text-muted-foreground">
            ← Swipe to see more testimonials →
          </p>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 text-center">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 px-6 sm:px-8 py-6 bg-card rounded-xl shadow-soft max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-xl sm:text-2xl font-bold text-primary">98%</div>
              <div className="text-xs sm:text-sm text-muted-foreground">Member Satisfaction</div>
            </div>
            <div className="hidden sm:block h-12 w-px bg-border"></div>
            <div className="sm:hidden h-px w-12 bg-border"></div>
            <div className="text-center">
              <div className="text-xl sm:text-2xl font-bold text-primary">4.9/5</div>
              <div className="text-xs sm:text-sm text-muted-foreground">Average Rating</div>
            </div>
            <div className="hidden sm:block h-12 w-px bg-border"></div>
            <div className="sm:hidden h-px w-12 bg-border"></div>
            <div className="text-center">
              <div className="text-xl sm:text-2xl font-bold text-primary">280+</div>
              <div className="text-xs sm:text-sm text-muted-foreground">Happy Members</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Testimonials;